export default __webpack_public_path__ + "static/media/lr.30be350e.svg";